export function die(error: Error): never {
  throw error
}
